import { render, staticRenderFns } from "./ProductStatics.vue?vue&type=template&id=16837538&"
import script from "./ProductStatics.vue?vue&type=script&lang=js&"
export * from "./ProductStatics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports